import React from 'react';
import PaymentPlanList from 'components/setup/PaymentPlan/PaymentPlanList';
import CustomerNote from 'components/setup/CustomerNote';
import {currentUser, duckify} from 'utils/duckify';

const PaymentPlanPage = ({currentUser, props}) => {
  return <React.Fragment>
    {currentUser.acl >= 4 && <CustomerNote isSuperAdmin={'true'} userName={currentUser.name} pageName={'payment_plan'}/>}
    <PaymentPlanList {...props}/>
  </React.Fragment>
}

const mapDucksToProps = () => ({ currentUser });
export default duckify(mapDucksToProps)(PaymentPlanPage);
